<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">My book was damaged when I got it</h1>
			<p>
				Contact the MP seller using <a
					:href="`/account/new_messages.php?action=thread&type=postsale&item_id=${parseInt($route.params.id)}#lastmessage`">this link</a>,
				and say this: <em>"Hello seller, when I got my book from you it was damaged. The damages are: ..."</em>
			</p>

			<p>
				If the seller doesn't reply to you within a couple of days, contact customer service and let us know. You can use this form:
			</p>

			<email-form
					subject="Book was damaged, seller didn't respond"
					:body="email_body"
					on-success-url="/help?#/submitted"
					edit-body
					class="h-email"
					:payload="{ order_line_id }"
					destination-key="cs"
			></email-form>


		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../components/BaseNavLinks';
	import EmailForm from './../../components/EmailForm';

	export default {
		name: "HelpRetailBookDamaged",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				order_line_id: null,
			};
		},

		computed: {
			email_body() {
				return `I contacted the seller to report it was damaged, but they didn't respond.`
			},
		},

		mounted() {
			this.order_line_id = parseInt(this.$route.params.id);
		}
	}
</script>

<style scoped lang="less">
	.h-email {
		margin-top: 10px;
	}
</style>